import { LocaleEnum as e } from "@systemeio/types";
//#region src/translations/locale-labels.ts
var t = {
	[e.ENGLISH]: "EN",
	[e.FRENCH]: "FR",
	[e.SPANISH]: "ES",
	[e.ITALIAN]: "IT",
	[e.PORTUGUESE]: "PT",
	[e.DEUTSCH]: "DE",
	[e.DUTCH]: "NL",
	[e.RUSSIAN]: "RU",
	[e.JAPANESE]: "JP",
	[e.ARABIC]: "AR",
	[e.TURKISH]: "TR",
	[e.CHINESE]: "CH",
	[e.SWEDISH]: "SV",
	[e.ROMANIAN]: "RO",
	[e.CZECH]: "CS",
	[e.HUNGARIAN]: "HU",
	[e.SLOVAK]: "SK",
	[e.DANISH]: "DK",
	[e.INDONESIAN]: "ID",
	[e.POLISH]: "PL",
	[e.GREEK]: "EL",
	[e.SERBIAN]: "SR",
	[e.HINDI]: "HI",
	[e.NORWEGIAN]: "NO",
	[e.THAI]: "TH",
	[e.SLOVENIAN]: "SL",
	[e.UKRAINIAN]: "UA",
	[e.ALBANIA]: "SQ"
}, n = {
	[e.ENGLISH]: "English",
	[e.FRENCH]: "Français",
	[e.SPANISH]: "Español",
	[e.ITALIAN]: "Italiano",
	[e.PORTUGUESE]: "Português",
	[e.DEUTSCH]: "Deutsch",
	[e.DUTCH]: "Nederlands",
	[e.RUSSIAN]: "Русский",
	[e.JAPANESE]: "日本語",
	[e.ARABIC]: "عربي",
	[e.TURKISH]: "Türkçe",
	[e.CHINESE]: "中文(简体)",
	[e.SWEDISH]: "Svenska",
	[e.ROMANIAN]: "Română",
	[e.CZECH]: "Čeština",
	[e.HUNGARIAN]: "Magyar",
	[e.SLOVAK]: "Slovenský",
	[e.DANISH]: "Dansk",
	[e.INDONESIAN]: "Indonesian",
	[e.POLISH]: "Polski",
	[e.GREEK]: "Ελληνικά",
	[e.SERBIAN]: "Srpski",
	[e.HINDI]: "Hindi",
	[e.NORWEGIAN]: "Norsk",
	[e.THAI]: "ไทย",
	[e.SLOVENIAN]: "Slovenski",
	[e.UKRAINIAN]: "Український",
	[e.ALBANIA]: "Shqiptare"
}, r = {
	[e.ENGLISH]: "locale.english",
	[e.FRENCH]: "locale.french",
	[e.SPANISH]: "locale.spanish",
	[e.ITALIAN]: "locale.italian",
	[e.PORTUGUESE]: "locale.portuguese",
	[e.DEUTSCH]: "locale.german",
	[e.DUTCH]: "locale.dutch",
	[e.RUSSIAN]: "locale.russian",
	[e.JAPANESE]: "locale.japanese",
	[e.CHINESE]: "locale.chinese",
	[e.TURKISH]: "locale.turkish",
	[e.ARABIC]: "locale.arabic",
	[e.SWEDISH]: "locale.swedish",
	[e.ROMANIAN]: "locale.romanian",
	[e.CZECH]: "locale.czech",
	[e.HUNGARIAN]: "locale.hungarian",
	[e.SLOVAK]: "locale.slovak",
	[e.DANISH]: "locale.danish",
	[e.INDONESIAN]: "locale.indonesian",
	[e.POLISH]: "locale.polish",
	[e.GREEK]: "locale.greek",
	[e.SERBIAN]: "locale.serbian",
	[e.HINDI]: "locale.hindi",
	[e.NORWEGIAN]: "locale.norwegian",
	[e.THAI]: "locale.thai",
	[e.SLOVENIAN]: "locale.slovenian",
	[e.UKRAINIAN]: "locale.ukrainian",
	[e.ALBANIA]: "locale.albania"
};
//#endregion
export { t as localeLabels, r as localeLanguages, n as localeNames };
